import React from 'react';
import PropTypes from 'prop-types';
import { SuiDropdown, SuiDropdownOption } from '@splashthat/sui';

import { SINGLE_CHECKBOX_OPERAND_OPTIONS } from 'common/compounds/FormBuilder/constants/operatorOptions';

const DROPDOWN_PLACEHOLDER = 'Pick your options';

const CheckboxOptionsDropdown = (props) => (
    <SuiDropdown
        fullWidth
        placeholder={DROPDOWN_PLACEHOLDER}
        value={props.value ? 1 : 0}
        onChange={(event, value) =>
            // eslint-disable-next-line eqeqeq
            props.onChange(event, { value: value == 1 })
        }
    >
        {Object.entries(SINGLE_CHECKBOX_OPERAND_OPTIONS).map(([optionKey, { value, label }]) => (
            <SuiDropdownOption key={value} displayValue={label} value={value} />
        ))}
    </SuiDropdown>
);

CheckboxOptionsDropdown.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    onChange: PropTypes.func.isRequired,
};

CheckboxOptionsDropdown.defaultProps = {
    value: null,
};

export default CheckboxOptionsDropdown;
